import { abTestStore } from '../stores'

const getAbTestStore = () => {
  let $val
  abTestStore.subscribe($ => $val = $)()
  return $val
}

export const getCookie = (cookieName) => {
  const cookieObj = new URLSearchParams(document.cookie.replace(/; /g, '&'))
  return cookieObj.get(cookieName) || undefined
}

export const getCurrentVwoContext = (campaignId) => {

  // Setup hidden logging
  const loggingEnabled = getCookie('ftr_x')

  // If VWO is not yet existing on window we push the event anyway which will be executed by VWO when the script is running.
  window.VWO = window.VWO || []

  const vwoData = {
    status: 'initial',
  }

  const getVwoVariationId = () => {
    const combiName = `_vis_opt_exp_${campaignId}_combi`
    const excludeName = `_vis_opt_exp_${campaignId}_exclude`
    const excludedCookie = getCookie(excludeName)
    const variationCookie = getCookie(combiName)

    if (loggingEnabled)
      console.log('Searching for VWO cookies:', combiName, excludeName)

    // If excluded cookie exist, the user wont be part of the test
    if (excludedCookie) {
      if (loggingEnabled)
        console.log('User excluded from VWO test:', excludedCookie)
      vwoData.status = 'done'
      return
    }

    // If variation cookie exist, the user will be part of the test
    if (variationCookie) {
      vwoData.variationId = variationCookie
      vwoData.campaignId = campaignId
      vwoData.status = 'done'
      if (loggingEnabled)
        console.log('Campaign cookie found, variation:', variationCookie)
      return
    }

    // This could happend if the user just accepted cookies or if no test exist.
    vwoData.status = 'pending'
  }

  getVwoVariationId()

  return vwoData
}

export const createAbTest = () => {
  const loggingEnabled = getCookie('ftr_x')

  // Poll for 2 secs to let the VWO cookie to settle before fetching the current VWO context
  const waitForCookieToSettle = async (campaignId) => {
    const abTestStoreData = getAbTestStore()
    for (let i = 0; i < 40; i++) {
      const result = getCurrentVwoContext(campaignId)
      if (result && result.status === 'pending') {
        await new Promise((resolve) =>
          setTimeout(function () {
            resolve(true)
          }, 50),
        )
      } else {
        abTestStore.set(result)
        if (loggingEnabled)
          console.log(
            `Success: VWO test ${campaignId} data found, breaking after ${
              i * 50
            }ms`,
          )
        break
      }
    }
    if (abTestStoreData && abTestStoreData.campaignId === undefined && loggingEnabled)
      console.log(
        `Warning: VWO test ${campaignId} doesn't exists, exiting after 2 seconds`,
      )
  }

  const startABTest = (campaignId) => {
    abTestStore.set({ campaignId })
    if (loggingEnabled)
      console.log(`Starting A/B test for campaign ID: ${campaignId}`, abTestStore.campaignId)
    waitForCookieToSettle(campaignId)
    window.addEventListener('OptanonConsentChanged', eventHandler)
  }

  const eventHandler = () => {
    if (loggingEnabled) console.log('OptanonConsentChanged event fired')
    waitForCookieToSettle(abTestStore.campaignId)
  }

  return { eventHandler, startABTest }
}
